'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keyMirror = require('react-utils/keyMirror');

var _keyMirror2 = _interopRequireDefault(_keyMirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _keyMirror2.default)({
  LOADING: null,
  SUCCEEDED: null,
  FAILED: null
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/constants/RequestStatusTypes.js
// module id = 50
// module chunks = 3 4 5